import { Component, ElementRef, ViewChild } from '@angular/core';
import { IonRouterOutlet, ModalController, IonSlides, IonSearchbar, AlertController, IonInput, IonFab } from '@ionic/angular';
import { AlertePage } from '../alerte/alerte.page';
import { ActivatedRoute, Router } from '@angular/router';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { mapStyle } from "./mapStyle";
import { NewPage } from '../new/new.page';
import { FirebaseService } from 'src/app/services/firebase.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoginPage } from '../public/login/login.page';
import { LostPasswordPage } from '../public/lost-password/lost-password.page';
import { RegisterPage } from '../public/register/register.page';
import { Keyboard } from '@capacitor/keyboard';
import { ViewerModalComponent } from 'ngx-ionic-image-viewer';
import { Tab1PicturesModal } from './tab1-pictures/tab1-pictures.page';
import { Events } from '@app/services/events.service';


declare const google;
declare const MarkerClusterer;

@Component({
  selector: 'app-tab1',
  templateUrl: 'tab1.page.html',
  styleUrls: ['tab1.page.scss']
})
export class Tab1Page {
  openModalId;
  segment = 'carte';
  search_text = '';
  error_code = 0;
  slideOpts = {
    slidesPerView: 1.1,
    spaceBetween: 15,
    centeredSlides: true
  }
  button_disabled = true;
  bounds: any;
  infowindow;
  markers = [];
  limitPictures = 150;

  icons = [];

  marker_active: any = null;

  alertes = [];
  alertes_filtered = [];
  alertes_pictures = [];
  communes = [];
  communes_data = {};
  id;
  isAnonymous = null;

  @ViewChild('slider', { static: true }) slider: IonSlides;
  @ViewChild("map", { static: true }) mapElement: ElementRef
  @ViewChild('searchbar', { static: true, read: IonInput }) searchbar: IonInput;
  // @ViewChild('slider') slider: IonSlides;
  map: any;
  googleAutocomplete: any;
  user: any;
  userData: any;
  user_position: any = null;
  constructor(
    private firebaseService: FirebaseService,
    private authService: AuthService,
    private router: Router,
    private alertCtrl: AlertController,
    private routerOutlet: IonRouterOutlet,
    private route: ActivatedRoute,
    private geolocation: Geolocation,
    private alertController: AlertController,
    private events: Events,
    private modalController: ModalController
  ) {

    this.events.subscribe('user', (user) => {
      console.log('events.subscribe user', user)
      this.isAnonymous = user == null
      console.log('events.subscribe this.isAnonymous', this.isAnonymous)
    });
    // if (this.authService.isAnonymous()) {
    //   console.log('did enter', 'anonymous true')
    //   this.isAnonymous = true;
    // }
  }

  ngOnInit() {
    console.log("ngOnInit");

    // setTimeout(async () => {
    //   console.log("this.alertes", this.alertes);
    //   const modal = await this.modalController.create({
    //     component: AlertePage,
    //     componentProps: { alerte: this.alertes[21] },
    //     canDismiss: true,
    //     presentingElement: this.routerOutlet.nativeEl
    //   });
    //   await modal.present();
    //   const { data } = await modal.onWillDismiss();
    //   console.log(data);
    // }, 2000)
  }

  ionViewDidEnter() {
    console.log("ionViewDidEnter", this.id);
    this.route.data.subscribe(async routeData => {
      console.log("routeData", routeData);
      this.openModalId = routeData['data'];
    });

    if (google != null)
      this.infowindow = new google.maps.InfoWindow({
        content: "loading..."
      });
    this.loadMap();
    this.initPlaces();
    this.refreshUser();
  }

  async refreshUser() {

    this.user = await this.firebaseService.getUser();
    this.isAnonymous = this.user == null;
    console.log("this.user", this.user);
  }
  ionViewDidLoad() {
    console.log("ionViewDidLoad");
    this.removeMarkers();
  }
  ionViewDidLeave() {
    console.log("ionViewDidLeave");
    this.clearMap();
  }

  handleKeyPress() {
    Keyboard.hide();
  }
  async search(search) {
    this.search_text = search;
    console.log('search', search);
    console.log('search_text', this.search_text);
    if (this.alertes.length == 0) {
      this.alertes = await this.firebaseService.getAlertes();
    }


    this.alertes_filtered = this.alertes.filter((alerte) => {
      if (alerte && alerte.locality && alerte.locality.toLowerCase().indexOf(this.search_text.toLowerCase()) >= 0)
        return true;
      if (alerte && alerte.localisation && alerte.localisation.address_components
        && alerte.localisation.address_components[0]
        && alerte.localisation.address_components[0].long_name.toLowerCase().indexOf(this.search_text.toLowerCase()) >= 0)
        return true;
      if (alerte && alerte.localisation && alerte.localisation.address_components
        && alerte.localisation.address_components[1]
        && alerte.localisation.address_components[1].long_name.toLowerCase().indexOf(this.search_text.toLowerCase()) >= 0)
        return true;
      if (alerte && alerte.localisation && alerte.localisation.address_components
        && alerte.localisation.address_components[2]
        && alerte.localisation.address_components[2].long_name.toLowerCase().indexOf(this.search_text.toLowerCase()) >= 0)
        return true;
      if (alerte && alerte.localisation && alerte.localisation.address_components
        && alerte.localisation.address_components[3]
        && alerte.localisation.address_components[3].long_name.toLowerCase().indexOf(this.search_text.toLowerCase()) >= 0)
        return true;
      if (alerte && alerte.localisation && alerte.localisation.address_components
        && alerte.localisation.address_components[4]
        && alerte.localisation.address_components[4].long_name.toLowerCase().indexOf(this.search_text.toLowerCase()) >= 0)
        return true;
      if (alerte && alerte.localisation && alerte.localisation.address_components
        && alerte.localisation.address_components[5]
        && alerte.localisation.address_components[5].long_name.toLowerCase().indexOf(this.search_text.toLowerCase()) >= 0)
        return true;
      else
        return false;
    })
    console.log("products_filtered", this.alertes_filtered)

  }

  hidePicture(alerte) {
    alerte.hidePicture = true;
    this.firebaseService.updateAlerte(alerte);

  }

  clearMap() {

    google.maps.event.clearListeners(this.infowindow);
    document.getElementById("map").innerHTML = '';

    var elements = document.getElementsByClassName("tap_listener");

    for (var i = 0; i < elements.length; i++) {
      elements[i].removeEventListener('click', this.myFunction);
    }

  }
  async initPlaces() {
    this.googleAutocomplete = new google.maps.places.Autocomplete(await this.searchbar.getInputElement());

    this.googleAutocomplete.addListener('place_changed', (results) => {
      // do whatever here
      // console.log("results", results);

      var place = this.googleAutocomplete.getPlace();

      if (!place.geometry) {
        // console.log('You entered: ' + place.name);
        return;
      }
      else {

        //   map.setCenter(place.geometry.location);
        // console.log("place.geometry.location.lat", place.geometry.location.lat);
        // console.log("place.geometry.location.lat()", place.geometry.location.lat());
        this.setUserPosition(place.geometry.location.lat(), place.geometry.location.lng());

      }

      // console.log('You selected: ', place);
    });
  }

  removeMarkers() {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }
    this.markers = [];
    this.icons = [];
  }

  async openViewer(alerte) {
    const modal = await this.modalController.create({
      component: Tab1PicturesModal,
      componentProps: {
        alerte
      },
      keyboardClose: true,
      showBackdrop: true
    });

    return await modal.present();
  }

  async refresh() {
    this.alertes = null;

    let alertes = await this.firebaseService.getAlertes();
    let communes = await this.firebaseService.getCommunes();
    // console.log("this.alertes before", JSON.parse(JSON.stringify(test)));
    // let final = JSON.parse(JSON.stringify(test));
    // final.unshift({
    //   first: true,
    // });
    // final.push({
    //   last: true,
    // });
    this.communes = communes;
    this.communes_data = {};
    for (let commune of communes) {
      this.communes_data[commune.locality] = commune;
    }
    this.alertes = alertes;
    this.alertes_filtered = JSON.parse(JSON.stringify(alertes));

    // let i = 0;
    // let phrases = [
    //   '"Le secret de l\'action c\'est de s\'y mettre.", disait le philosophe Alain. Bravo aux hommes d\'actions de la Mairie de Saint-Père-Marc-en-Poulet.',
    //   'Texte B',
    //   'Texte C',
    //   'Texte D'
    // ]
    this.alertes_pictures = JSON.parse(JSON.stringify(this.alertes_filtered))
      .reverse()
      .sort((alerte) => {
        return alerte.picture_after ? -1 : 1;
      })
      .filter((alerte) => {
        // if(alerte.picture_after){
        //   alerte.message_after = phrases[i];
        //   i++;
        // }
        return !alerte.hidePicture;
      })
    // this.alertes.push({
    //   last: true,
    // });
    // this.alertes.push({
    //   last: true,
    //   transparent: true
    // });

    if (this.openModalId) {
      console.log("this.alertes_filtered", this.alertes_filtered);
      console.log("this.openModalId", this.openModalId);
      let alerte_index = this.alertes_filtered.findIndex((alerte) => {
        return alerte.id == this.openModalId;
      })
      this.goToAlerteFiltered(alerte_index);
      this.openModalId = '';
    }

    console.log("this.alertes after", JSON.parse(JSON.stringify(this.alertes)));
    this.addAlertes();
    this.getPosition();
  }



  setUserPosition(lat, lng) {
    if (this.user == null) {
      this.user = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: this.map
      });
    } else {
      this.user.setPosition({ lat: lat, lng: lng });

      // user.setTitle(place.formatted_address);
    }
    this.map.setCenter({ lat: lat, lng: lng });
  }

  loadMap() {
    let myLocation = { lat: 47.2580664, lng: 2.4801888 };
    let style = [];
    style = mapStyle;
    this.map = new google.maps.Map(this.mapElement.nativeElement, {
      controls: {
        myLocationButton: true,
        indoorPicker: true,
        disableDefaultUI: true,
      },
      styles: style,
      disableDefaultUI: true,
      MyLocationEnabled: true,
      setMyLocationButtonEnabled: true,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      },
      compass: true,
      zoom: 4,
      center: { lat: 47.2580664, lng: 2.4801888 },
      mapTypeId: "roadmap"
    });

    this.bounds = new google.maps.LatLngBounds(); // Zone des markers

    this.refresh();
  }

  getPosition(show_error = false) {
    var options = {
      // enableHighAccuracy: true,
      // timeout: 8000,
      // maximumAge: 3000
    };
    console.log("getPosition");
    this.geolocation
      .getCurrentPosition({ timeout: 5000, maximumAge: 15000, enableHighAccuracy: true })
      .then(async resp => {
        console.log("getPosition resp", resp);
        // resp.coords.latitude
        // resp.coords.longitude
        // let latLng = new LatLng(resp.coords.latitude, resp.coords.longitude);
        // console.log("setZoom + panTo");
        if (this.segment != 'zoom') {
          this.map.setZoom(12);
          this.map.panTo({ lat: resp.coords.latitude, lng: resp.coords.longitude });
        }

        let icon_circle = {
          url: 'assets/markers/location.png',
          scaledSize: new google.maps.Size(40, 40),
          anchor: new google.maps.Point(20, 20),
        };

        this.user_position = { lat: resp.coords.latitude, lng: resp.coords.longitude, date: new Date().toISOString() };
        new google.maps.Marker({
          position: { lat: resp.coords.latitude, lng: resp.coords.longitude },
          map: this.map,
          icon: icon_circle,
          zIndex: 0
        });
        this.button_disabled = false;
      })
      .catch(error => {
        this.button_disabled = false;
        console.log("Error getting location", error.code, error);
        // this.presentAlertLocationDenied('Aie ! Nous n\'avons pas réussi à vous localiser, votre position n\'est pas disponible, il y a certainement un problème de réseau. <br /><br /> Vous pouvez tout de même signaler une pollution, vous localiser manuellement et importer une photo.');

        // return this.error_code = 2;
        if (error.code == 1) //User denied Geolocation
          this.presentAlertLocationDenied('Aie ! Nous n\'avons pas réussi à vous localiser, il semblerait que vous n\'ayez pas activé le partage de votre localisation, veuillez activer la géolocalisation dans les paramètres de votre téléphone. ');
        if (error.code == 2) //User denied Geolocation
          this.presentAlertLocationDenied('Aie ! Nous n\'avons pas réussi à vous localiser, votre position n\'est pas disponible, il y a certainement un problème de réseau. <br /><br /> Vous pouvez tout de même signaler une pollution, vous localiser manuellement et importer une photo.');
        if (error.code == 3) //User denied Geolocation
          this.presentAlertLocationDenied('Merci d\'activer la géolocalisation dans vos paramètres > connexion > position > méthode de localisation > haute précision (ou économie de la batterie)', true);
        this.error_code = error.code;
      });
  }


  async presentAlertLocationDenied(message, test = false) {
    console.log("presentAlertLocationDenied");
    const alert = await this.alertController.create({
      mode: 'ios',
      header: 'Localisation introuvable',
      message: message,
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
            if (test)
              return this.getPosition(true);
          }
        }
      ]
    });
    await alert.present();
  }

  goSwipe() {
    this.router.navigate(["/tab1/swipe"]);
  }

  async goProducts() {
    this.router.navigate(["/tab1/products"]);
  }


  async presentAlert(title: string, message: string) {

    // google.maps.event.clearListeners(this.infowindow);
    // this.refresh();
    const alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });
    await alert.present();
  }


  async presentAlertNeedAuth() {
    const alert = await this.alertController.create({
      mode: 'ios',
      header: 'Connexion obligatoire',
      message: 'L\'ajout d\'une alerte necéssite d\'être <strong>connecté</strong>!!!',
      buttons: [
        {
          text: 'Annuler',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Connexion',
          handler: () => {
            console.log('Confirm Okay');
            this.presentModalLogin();
          }
        }
      ]
    });

    await alert.present();
  }
  async presentAlertEmail() {
    const alert = await this.alertController.create({
      mode: 'ios',
      header: 'Vérification de l\'email',
      message: 'Nous devons vérifier votre email pour pouvoir ajouter une alerte',
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }
      ]
    });

    await alert.present();
  }


  async newAlerte(check_position = true) {
    console.log("check_position", check_position);
    console.log("this.user_position", this.user_position);
    if (this.authService.isAnonymous()) {
      return this.presentAlertNeedAuth();
    }
    // if (this.authService.()) {
    // this.authService.sendVerificationMail();
    // return this.presentAlertEmail();
    // }
    if (check_position && this.user_position == null) {
      if (this.error_code == 1) //User denied Geolocation
        return this.presentAlertLocationDenied('Aie ! Nous n\'avons pas réussi à vous localiser, il semblerait que vous n\'ayez pas activé le partage de votre localisation, veuillez activer la géolocalisation dans les paramètres de votre téléphone. ');
      if (this.error_code == 3) //User denied Geolocation
        return this.presentAlertLocationDenied('Merci d\'activer la géolocalisation dans vos paramètres > connexion > position > méthode de localisation > haute précision (ou économie de la batterie)', true);

    }
    const modal = await this.modalController.create({
      component: NewPage,
      componentProps: { user_position: this.user_position, show_alert: this.error_code == 2 },
      canDismiss: true
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    setTimeout(() => {

      this.refresh();
    }, 1000)
    if (data != null) {

      //   google.maps.event.clearListeners(this.infowindow);
    }
  }
  async goToAlerteFiltered(marker_id = null) {

    const modal = await this.modalController.create({
      component: AlertePage,
      componentProps: { alerte: this.alertes_filtered[marker_id] },
      canDismiss: true
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
  }
  async goToAlerte(marker_id = null) {
    console.log("goToAlerte", marker_id);
    console.log("this.communes", this.communes);
    console.log("alerte", this.alertes[marker_id]);
    let commune_abonne = -1;
    if (this.alertes[marker_id]["locality"] != null) {
      commune_abonne = this.communes.findIndex((commune) => {
        return commune["locality"] == this.alertes[marker_id]["locality"];
      })
      console.log("commune_abonne", commune_abonne)
    }
    if (this.alertes[marker_id]["locality"] == null || commune_abonne == -1) {
      this.presentAlert('Commune non abonnée', 'Nous avons communiqué votre signalisation à la commune concernée. Nous ne pouvons pas vous transmettre le suivi en images des actions menées en réponse à votre alerte, car le territoire n\'est pas abonné au service. Merci de votre compréhension.À bientôt!')
      return;
    }
    const modal = await this.modalController.create({
      component: AlertePage,
      componentProps: { alerte: this.alertes[marker_id] },
      canDismiss: true
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    // if (data != null) {
    // this.refresh();
    // }
  }

  goPrev() {
    // console.log("goPrev marker_active", JSON.parse(JSON.stringify(this.marker_active)));
    if (this.marker_active <= 0)
      this.marker_active = this.markers.length - 1;
    else
      this.marker_active -= 1;
    google.maps.event.trigger(this.markers[this.marker_active], "click");
  }
  goNext() {
    // console.log("goNext marker_active", JSON.parse(JSON.stringify(this.marker_active)));

    if (this.marker_active >= this.markers.length - 1)
      this.marker_active = 0;
    else
      this.marker_active += 1;
    google.maps.event.trigger(this.markers[this.marker_active], "click");
  }
  setInfo(marker) {
    // console.log("marker", marker);
    // console.log("this.alertes[1]", this.alertes[marker.id]);
    let alerte = this.alertes[marker.id];


    let commune_abonne = -1;
    if (alerte["locality"] != null) {
      commune_abonne = this.communes.findIndex((commune) => {
        return commune["locality"] == alerte["locality"];
      })
      console.log("commune_abonne", commune_abonne)
    }



    let options = (alerte.dechets ? 'Déchets' : '') + '' + (alerte.dechets && alerte.degradations ? ', ' : '') + '' + (alerte.degradations ? 'Dégradations' : '');

    let button = '';
    if (alerte["locality"] != null && commune_abonne >= 0) {
      // COMMUNE ABONNÉE ET SIGNALISATION TRAITÉ
      if (alerte.statut == 'ended')
        button = '<ion-button mode="ios" class="tap_listener" data-id="' + marker.id + '"  expand="block" size="small" color="primary">Voir le détail</ion-button>';
      else {
        // COMMUNE ABONNE ET SIGNALISATION NON TRAITÉ  
        // button = '<b>Action en cours</b>';
        //<ion-button mode="ios" class="tap_listener" data-id="' + marker.id + '"  expand="block" color="tertiary">Voir le détail</ion-button>';
      }

    }
    else {
      // color_1 = '#FA530C';
      // color_2 = '#FF9008';
      // COMMUNE NON ABONNÉE
      // if (alerte["locality"] == null || commune_abonne == -1 || alerte.private) {
      button = '<ion-button mode="ios"  class="tap_listener" data-id="' + marker.id + '"  expand="block"  size="small"  color="primary">En savoir plus</ion-button>';
    }

    let description = '<i>';
    if (alerte.statut == 'waiting')
      description += 'Signalisation transmise';
    if (alerte.statut == 'planned')
      description += 'Signalisation en cours de traitement';
    if (alerte.statut == 'ended')
      description += 'Signalisation traitée';
    if (alerte.private)
      description += '<br/>Terrain privé (pas de localisation précise)';
    description += '</i><br />';

    // color_2 = '#0c9ef9';
    // color_1 = '#0a86d3';
    if (alerte["locality"] == null || commune_abonne == -1) {
      description += '<span style="color: #0a86d3;font-weight : bold;">Commune non abonnée</span><br />';
    }
    else {
      description += '<span>Commune abonnée</span><br />';
    }

    let message_adresse = "";
    if (alerte.private)
      message_adresse = '<span class="inline">' + alerte.locality + '</span><br />'
    if (!alerte.private)
      message_adresse = '<span class="inline">' + alerte.localisation.text + '</span><br />'
    let ville_abo = '';
    let infos = '<img class="picto_black" src="assets/icon/picto_black.svg" />Information transmise<br /></span>';
    if (alerte.statut == 'ended')
      infos = '<img class="picto_valide" src="assets/icon/picto_valide.svg" />Pollution traitée<br /></span>';

    if (this.communes_data[alerte.locality])
      ville_abo = '<span><img class="ville_abo" src="assets/icon/picto_abonne.svg" /> Ville  abonnée <br /> </span>';

    let content =
      '<div id="content" class="infobox">' +
      // '<img class="picture" style="object-fit:contain; width: 262px;margin-bottom : 10px;" src="' + alerte.picture + '" />' +
      '<ion-thumbnail class="list_thumbnail taille_' + alerte.taille + '" slot="start">' +
      '<img class="list_icon taille_' + alerte.taille + '" src = "assets/icon/stetho_' + alerte.taille + '.svg" />' +
      '<span class="list_taille taille_' + alerte.taille + '">' + alerte.taille + 'm<sup>3</sup></span >' +
      '</ion-thumbnail>' +
      '<ion-label class="ion-text-wrap">' +
      '<ion-text > <h3>' + alerte.localisation.location.lat.toFixed(4) + '/' + alerte.localisation.location.lng.toFixed(4) +
      '<br />' + alerte.locality + '</h3></ion-text><p class="list_ul">' +
      '' + ville_abo + '' +
      '' + infos + '' +
      '</p>' +
      '' + button + '' +
      '</ion-label>' +
      '</div>';


    this.infowindow.setContent(content);
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  async segmentChanged(event) {
    console.log('segmentChanged', event);
    if (event.detail.value == 'zoom') {
      this.userData = await this.authService.getUser();
      console.log('this.userData', this.userData);
      this.map.setZoom(4);

      this.map.setCenter({ lat: 47.2580664, lng: 6.4801888 });
    }
  }

  handleRefresh(event) {
    console.log('this.handleRefresh', event);
    setTimeout(() => {
      // Any calls to load data go here
      this.limitPictures += 10;
      event.target.complete();
    }, 100);
  };
  addAlertes() {
    this.removeMarkers();
    this.alertes.map((alerte, i) => {
      if (!alerte.last && !alerte.first) {

        let commune_abonne = -1;
        if (alerte["locality"] != null) {
          commune_abonne = this.communes.findIndex((commune) => {
            return commune["locality"] == alerte["locality"];
          })
          // console.log("commune_abonne", commune_abonne)
        }
        alerte.commune_find = true;
        if (alerte["locality"] == null || commune_abonne == -1) {
          alerte.commune_find = false;
        }

        this.generateIcon(alerte, i);
        let selected_location = alerte.localisation.location;
        if (alerte.private && alerte.localisation) {
          selected_location = alerte.localisation.location;
          selected_location.lat += 0.003;
          // selected_location.lat += (5 - this.getRandomInt(10)) / 100;
          // selected_location.lng += (5 - this.getRandomInt(10)) / 1000;
        }
        let marker = new google.maps.Marker({
          position: { lat: parseFloat(selected_location.lat), lng: parseFloat(selected_location.lng) },
          optimized: false,
          map: this.map,
          icon: this.icons[i]['classic'],
          zIndex: 1,
        });
        marker.set("id", i);
        google.maps.event.addDomListener(marker, 'click', () => {
          console.log("click", this.marker_active);
          if (this.marker_active != null)
            this.markers[this.marker_active].setIcon(this.icons[this.marker_active]['classic']);
          // console.log("alerte.localisation", alerte.localisation);
          this.marker_active = i;
          this.setInfo(marker);
          this.infowindow.open(this.map, marker);
          this.map.panTo({ lat: parseFloat(alerte.localisation.location.lat), lng: parseFloat(alerte.localisation.location.lng) });
          this.map.panBy(0, -50);
          marker.setIcon(this.icons[i]['active']);
          // console.log("marker click", marker.id);
          // console.log("marker marker_active", this.marker_active);
          // 
          // console.log("marker",marker);
          // console.log("marker.icon",marker.icon);
          // console.log("marker.icon.src",marker.icon.url);

          // console.log(document.querySelectorAll('img[src="'+marker.icon.url+'"]'));

          // this.slider.slideTo(i);
        });
        this.markers.push(marker);
        return;
      }
    });
    // console.log("this.markers", this.markers);

    let options = {
      cssClass: 'custom-pin'
    };


    // Redéfinit la zone des markers
    // this.setBounds();

    // Ci-dessous, le clustering éventuel

    let cluster; // Le MarkerClusterer
    let clusterOptions = {
      gridSize: 60, // 60 par défaut
      maxZoom: 11, // Désactive le clustering au delà de ce niveau de zoom
      styles: [
        {
          url: '/assets/markers/m1.png',
          height: 53,
          width: 53,
          anchor: [0, 0],
          textColor: '#ffffff',
          textSize: 16
        },
        {
          url: '/assets/markers/m2.png',
          height: 53,
          width: 53,
          anchor: [0, 0],
          textColor: '#ffffff',
          textSize: 16
        },
        {
          url: '/assets/markers/m3.png',
          height: 53,
          width: 53,
          anchor: [0, 0],
          textColor: '#ffffff',
          textSize: 16
        },
        {
          url: '/assets/markers/m4.png',
          height: 53,
          width: 53,
          anchor: [0, 0],
          textColor: '#ffffff',
          textSize: 16
        },
        {
          url: '/assets/markers/m5.png',
          height: 53,
          width: 53,
          anchor: [0, 0],
          textColor: '#ffffff',
          textSize: 16
        },
      ]
      //         height: 45,
      //         width: 45,
      //         anchor: [0, 0],
      //         textColor: '#ffffff',
      //         textSize: 16
      // }]*/
    };

    // cluster = new MarkerClusterer(this.map, this.markers, clusterOptions);


    // Add a marker clusterer to manage the markers.
    // new MarkerClusterer(this.map, this.markers,{imagePath: 'assets/markers/m'},options);

    // var myoverlay = new google.maps.OverlayView();
    // myoverlay.draw = function () {
    //   // console.log(this.getPanes());
    //   this.getPanes().markerLayer.id = 'markerLayer';
    // }
    // myoverlay.setMap(this.map);

    google.maps.event.addListener(this.infowindow, 'domready', () => {
      var elements = document.getElementsByClassName("tap_listener");


      for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', this.myFunction, false);
      }
      // document.getElementById('tap').addEventListener('click', (e) => {
      //   //alert('Clicked');
      //   console.log("touch", e);
      //   this.goToAlerte(e.srcElement["dataset"].id)
      // }, false);
    });

    // this.goToAlerte(33);
  }


  myFunction = (e: any) => {
    console.log("touch", e);
    this.goToAlerte(e.srcElement["dataset"].id)
  };
  /**
   * Redéfinit le centre de la carte pour l'adapter à la zone des markers,
   * avec un niveau de zoom maximal.
   */
  setBounds() {

    this.map.setCenter(this.bounds.getCenter());
    this.map.fitBounds(this.bounds);
    if (this.map.getZoom() > 13) this.map.setZoom(13);
  }

  async slideChanged() {
    let currentIndex = await this.slider.getActiveIndex();
    this.setActiveCard(currentIndex);

  }

  setActiveCard(index) {
    // console.log("index", index);
    // console.log("alertes", this.alertes[index]);
    // console.log("markers", this.markers);
    // console.log("icons", this.icons);
    // console.log("marker_active", this.marker_active);
    if (this.alertes[index].last || this.alertes[index].first) {
      this.map.setZoom(12);
      // console.log("this.user.getPosition(); ", this.user.getPosition().lat());
      this.map.panTo({ lat: this.user.getPosition().lat(), lng: this.user.getPosition().lng() });
      return
    }

    if (this.marker_active != null) {// && this.marker_active != index - 1) {
      this.markers[this.marker_active - 1].setIcon(this.icons[this.marker_active]['classic']);
    }
    if (this.icons[index] && this.markers[index - 1]) {
      this.markers[index - 1].setIcon(this.icons[index]['active']);
      this.marker_active = this.markers[index - 1].id;
      this.map.setZoom(13);
      this.map.panTo({ lat: parseFloat(this.alertes[index].localisation.location.lat), lng: parseFloat(this.alertes[index].localisation.location.lng) });
      // this.map.panTo({ lat: parseFloat(this.alertes[index].localisation.location.lat), lng: parseFloat(this.alertes[index].localisation.location.lng) });
    }
  }

  generateIcon(alerte: any, i: number) {


    let icon_marker = '<circle fill="#40a8d1" cx="27.5" cy="21" r="8" />';
    let icon_marker_active = '<circle fill="#fff" cx="27.5" cy="21" r="8" />';
    let icon_picture = 'm1';


    let commune_abonne = -1;
    if (alerte["locality"] != null) {
      commune_abonne = this.communes.findIndex((commune) => {
        return commune["locality"] == alerte["locality"];
      })
      // console.log("commune_abonne", commune_abonne)
    }

    if (alerte.statut == 'ended' && alerte.locality && commune_abonne >= 0) {
      // VERT
      icon_picture = 'm1';
      icon_marker = '<g transform="translate(16.5 10) scale(0.8 0.8)"><path fill="#40a8d1" d="M149.456,43.1c-.472.472-.951.941-1.42,1.42a3.55,3.55,0,0,0-1.02,2.471c0,.359,0,.722,0,1.081a9.617,9.617,0,0,1-.024,1.256c.014-.092.024-.181.038-.274a2.625,2.625,0,0,1-.171.623l.1-.246a2.944,2.944,0,0,1-.212.4c-.02.031-.044.062-.065.092-.055.089.181-.212.065-.086-.051.055-.1.113-.151.164s-.11.1-.164.151c-.106.1.1-.079.1-.079s-.079.055-.092.065a2.337,2.337,0,0,1-.418.226l.246-.1a2.628,2.628,0,0,1-.623.171l.274-.038a9.811,9.811,0,0,1-1.188.024c-.387,0-.77,0-1.157,0a3.572,3.572,0,0,0-2.488,1.044c-.3.3-.606.606-.91.91l-.445.445c-.062.062-.123.12-.188.178-.144.13.212-.147.051-.038a1.68,1.68,0,0,1-.164.106,2.494,2.494,0,0,1-.3.154l.246-.1a2.568,2.568,0,0,1-.64.175l.274-.038a2.639,2.639,0,0,1-.657,0l.274.038a2.652,2.652,0,0,1-.64-.175l.246.1a3.692,3.692,0,0,1-.5-.291c.281.178.051.034-.021-.034-.017-.017-.038-.034-.055-.055l-.335-.335-.986-.986a3.677,3.677,0,0,0-2.32-1.092c-.39-.034-.787-.01-1.177-.01a11.065,11.065,0,0,1-1.389-.024l.274.038a2.628,2.628,0,0,1-.623-.171l.246.1a2.944,2.944,0,0,1-.4-.212c-.031-.021-.062-.044-.092-.065-.089-.055.212.181.086.065-.055-.051-.113-.1-.164-.151s-.1-.11-.151-.164c-.1-.106.079.1.079.1s-.055-.079-.065-.092a2.337,2.337,0,0,1-.226-.418l.1.246a2.628,2.628,0,0,1-.171-.623c.014.092.024.181.038.274a9.815,9.815,0,0,1-.024-1.188c0-.387,0-.77,0-1.157a3.571,3.571,0,0,0-1.044-2.488c-.3-.3-.606-.606-.91-.91l-.445-.445c-.062-.062-.12-.123-.178-.188-.13-.144.147.212.038.051a1.675,1.675,0,0,1-.106-.164,2.485,2.485,0,0,1-.154-.3l.1.246a2.57,2.57,0,0,1-.174-.64c.014.092.024.181.038.274a2.637,2.637,0,0,1,0-.657c-.014.092-.024.181-.038.274a2.652,2.652,0,0,1,.174-.64l-.1.246a3.691,3.691,0,0,1,.291-.5c-.178.281-.034.051.034-.021.017-.017.034-.038.055-.055l.335-.335.986-.986a3.669,3.669,0,0,0,1.092-2.32c.034-.39.01-.787.01-1.177a11.07,11.07,0,0,1,.024-1.389c-.014.092-.024.181-.038.274a2.629,2.629,0,0,1,.171-.623l-.1.246a2.941,2.941,0,0,1,.212-.4c.02-.031.045-.062.065-.092.055-.089-.181.212-.065.086.051-.055.1-.113.151-.164s.109-.1.164-.151c.106-.1-.1.079-.1.079s.079-.055.092-.065a2.335,2.335,0,0,1,.417-.226l-.246.1a2.627,2.627,0,0,1,.623-.171l-.274.038a9.809,9.809,0,0,1,1.188-.024c.387,0,.77,0,1.157,0a3.572,3.572,0,0,0,2.488-1.044c.3-.3.606-.606.91-.91l.445-.445c.062-.062.123-.12.188-.178.144-.13-.212.147-.051.038a1.682,1.682,0,0,1,.164-.106,2.5,2.5,0,0,1,.3-.154l-.246.1a2.569,2.569,0,0,1,.64-.175l-.274.038a2.638,2.638,0,0,1,.657,0l-.274-.038a2.651,2.651,0,0,1,.64.175l-.246-.1a3.687,3.687,0,0,1,.5.291c-.281-.178-.051-.034.021.034.017.017.038.034.055.055l.335.335.986.986a3.677,3.677,0,0,0,2.32,1.092c.39.034.787.01,1.177.01a11.064,11.064,0,0,1,1.389.024l-.274-.038a2.628,2.628,0,0,1,.623.171l-.246-.1a2.948,2.948,0,0,1,.4.212c.031.021.062.044.092.065.089.055-.212-.181-.086-.065.055.051.113.1.164.151s.1.11.151.164c.1.106-.079-.1-.079-.1s.055.079.065.092a2.341,2.341,0,0,1,.226.418l-.1-.246a2.626,2.626,0,0,1,.171.623c-.014-.092-.024-.181-.038-.274a9.805,9.805,0,0,1,.024,1.188c0,.387,0,.77,0,1.157a3.571,3.571,0,0,0,1.044,2.488c.3.3.606.606.91.91l.445.445c.062.062.12.123.178.188.13.144-.147-.212-.038-.051a1.672,1.672,0,0,1,.106.164,2.491,2.491,0,0,1,.154.3l-.1-.246a2.571,2.571,0,0,1,.175.64c-.014-.092-.024-.181-.038-.274a2.636,2.636,0,0,1,0,.657c.014-.092.024-.181.038-.274a2.654,2.654,0,0,1-.175.64l.1-.246a2.739,2.739,0,0,1-.205.383c-.017.027-.038.055-.055.082-.079.116.065-.079.072-.089a1.09,1.09,0,0,1-.175.181,1.026,1.026,0,1,0,1.451,1.451,3.523,3.523,0,0,0,.489-4.309,5.653,5.653,0,0,0-.78-.907l-.835-.835c-.092-.092-.188-.185-.281-.281-.068-.072-.13-.147-.2-.219.212.236.024.021-.027-.065a2.573,2.573,0,0,1-.147-.291l.1.246a2.559,2.559,0,0,1-.174-.633c.014.092.024.181.038.274a11.772,11.772,0,0,1-.024-1.475,6.982,6.982,0,0,0-.113-1.752,3.53,3.53,0,0,0-2.18-2.385,4.921,4.921,0,0,0-1.827-.212,13.482,13.482,0,0,1-1.7-.024l.274.038a2.559,2.559,0,0,1-.633-.175l.246.1a2.664,2.664,0,0,1-.339-.178c-.041-.024-.216-.154-.075-.045s-.048-.044-.086-.079-.1-.092-.144-.14l-.568-.568a9.519,9.519,0,0,0-1.342-1.232,3.516,3.516,0,0,0-3.46-.181,5.723,5.723,0,0,0-1.492,1.246l-.681.681c-.044.044-.089.092-.137.137s-.092.089-.144.133c-.014.014-.044.048-.065.051.048-.01.2-.147.051-.048a2.77,2.77,0,0,1-.407.222l.246-.1a2.56,2.56,0,0,1-.633.175l.274-.038a11.781,11.781,0,0,1-1.475.024,6.984,6.984,0,0,0-1.752.113A3.53,3.53,0,0,0,128.518,34a4.922,4.922,0,0,0-.212,1.827,13.48,13.48,0,0,1-.024,1.7c.014-.092.024-.181.038-.274a2.561,2.561,0,0,1-.175.633l.1-.246a2.661,2.661,0,0,1-.178.339c-.024.041-.154.216-.044.075s-.044.048-.079.086-.092.1-.14.144l-.568.568a9.518,9.518,0,0,0-1.232,1.342,3.517,3.517,0,0,0-.181,3.46,5.722,5.722,0,0,0,1.246,1.492l.681.681c.044.045.092.089.137.137s.089.092.133.144c.014.014.048.044.051.065-.01-.048-.147-.2-.048-.051a2.77,2.77,0,0,1,.222.407l-.1-.246a2.561,2.561,0,0,1,.175.633c-.014-.092-.024-.181-.038-.274a11.775,11.775,0,0,1,.024,1.475,6.984,6.984,0,0,0,.113,1.752,3.53,3.53,0,0,0,2.18,2.385,4.921,4.921,0,0,0,1.827.212,13.478,13.478,0,0,1,1.7.024l-.274-.038a2.56,2.56,0,0,1,.633.175l-.246-.1a2.665,2.665,0,0,1,.339.178c.041.024.216.154.075.044s.048.044.086.079.1.092.144.14l.568.568a9.518,9.518,0,0,0,1.342,1.232,3.516,3.516,0,0,0,3.46.181,5.721,5.721,0,0,0,1.492-1.246l.681-.681c.045-.045.089-.092.137-.137s.092-.089.144-.133c.014-.014.044-.048.065-.051-.048.01-.2.147-.051.048a2.768,2.768,0,0,1,.407-.222l-.246.1a2.558,2.558,0,0,1,.633-.175l-.274.038a11.778,11.778,0,0,1,1.475-.024,6.985,6.985,0,0,0,1.752-.113,3.53,3.53,0,0,0,2.385-2.18,4.921,4.921,0,0,0,.212-1.827,13.48,13.48,0,0,1,.024-1.7c-.014.092-.024.181-.038.274a2.559,2.559,0,0,1,.174-.633l-.1.246a2.669,2.669,0,0,1,.178-.339c.027-.044.065-.089.092-.137-.144.246-.079.1-.024.034s.106-.116.164-.171l.472-.472.9-.9a1.039,1.039,0,0,0,0-1.451A1.05,1.05,0,0,0,149.456,43.1Z" transform="translate(-125.457 -28.857)"/><g transform="translate(6.613 6.617)"><path fill="#40a8d1" d="M329.861,228.831a5.663,5.663,0,0,1-.051.76c.014-.092.024-.181.038-.274a5.788,5.788,0,0,1-.387,1.417l.1-.246a5.681,5.681,0,0,1-.5.931c-.051.075-.1.147-.154.219-.1.144.062-.062.065-.082,0,.027-.065.079-.085.106-.113.137-.233.27-.359.4s-.247.236-.38.346c-.034.027-.068.055-.1.086-.092.079.212-.157.082-.065-.072.051-.144.106-.219.157a5.776,5.776,0,0,1-.948.517l.246-.1a5.541,5.541,0,0,1-1.417.387l.274-.038a5.924,5.924,0,0,1-1.516,0l.274.038A5.793,5.793,0,0,1,323.4,233l.246.1a5.688,5.688,0,0,1-.931-.5c-.075-.051-.147-.1-.219-.154-.144-.1.062.062.082.065-.027,0-.079-.065-.106-.086-.137-.113-.27-.233-.4-.359s-.236-.246-.346-.38c-.027-.034-.055-.068-.086-.1-.078-.092.158.212.065.082-.051-.072-.106-.144-.157-.219a5.764,5.764,0,0,1-.517-.948l.1.246a5.541,5.541,0,0,1-.387-1.417c.014.092.024.181.038.274a5.923,5.923,0,0,1,0-1.516c-.014.092-.024.181-.038.274a5.791,5.791,0,0,1,.387-1.417l-.1.246a5.683,5.683,0,0,1,.5-.931c.051-.075.1-.147.154-.219.1-.144-.062.062-.065.082,0-.027.065-.079.086-.106.113-.137.233-.27.359-.4s.246-.236.38-.346c.034-.027.068-.055.1-.086.092-.079-.212.157-.082.065.072-.051.144-.106.219-.157a5.759,5.759,0,0,1,.948-.517l-.246.1a5.539,5.539,0,0,1,1.417-.387l-.274.038a5.918,5.918,0,0,1,1.516,0c-.093-.014-.182-.024-.274-.038a5.8,5.8,0,0,1,1.417.387l-.246-.1a5.676,5.676,0,0,1,.931.5c.075.051.147.1.219.154.144.1-.062-.062-.082-.065.027,0,.079.065.106.086.137.113.27.233.4.359s.236.246.346.38c.027.034.055.068.086.1.079.092-.157-.212-.065-.082.051.072.106.144.157.219a5.768,5.768,0,0,1,.517.948l-.1-.246a5.536,5.536,0,0,1,.387,1.417c-.014-.092-.024-.181-.038-.274a6.969,6.969,0,0,1,.051.756,1.027,1.027,0,1,0,2.053,0,6.594,6.594,0,0,0-1.184-3.771,6.83,6.83,0,0,0-3.237-2.467,6.63,6.63,0,0,0-7.235,1.961,6.8,6.8,0,0,0-1.56,3.854,6.6,6.6,0,0,0,3.781,6.413,6.805,6.805,0,0,0,4.2.489,6.627,6.627,0,0,0,5.14-5.346,7.738,7.738,0,0,0,.1-1.126,1.028,1.028,0,0,0-2.057-.007Z" transform="translate(-318.68 -222.217)"/></g><g transform="translate(7.082 21.561)"><g transform="translate(0 0)"><path fill="#40a8d1" d="M342.633,659.921v9.459c.435-.329.866-.661,1.3-.989l-4.511-1.841c-.2-.082-.393-.171-.6-.243a1.255,1.255,0,0,0-.941.154c-.876.356-1.749.715-2.625,1.071l-2.1.859c.435.329.866.661,1.3.989v-9.459l-1.027,1.027a4.309,4.309,0,0,1,.554.024l-.274-.037a2.542,2.542,0,0,1,.633.175l-.246-.1a2.686,2.686,0,0,1,.339.178c.041.024.216.154.075.044s.048.045.086.079.1.093.144.14l.568.568a9.531,9.531,0,0,0,1.341,1.232,3.516,3.516,0,0,0,3.46.181,5.722,5.722,0,0,0,1.492-1.246l.681-.681c.045-.044.089-.092.137-.137s.092-.089.144-.133c.014-.014.045-.048.065-.051-.048.01-.2.147-.051.048a2.76,2.76,0,0,1,.407-.222l-.246.1a2.542,2.542,0,0,1,.633-.175l-.274.037a4.308,4.308,0,0,1,.554-.024,1.027,1.027,0,0,0,0-2.053,4.035,4.035,0,0,0-.5.017,3.976,3.976,0,0,0-1.2.322,3.545,3.545,0,0,0-1.054.756l-1.225,1.225-.14.14c-.031.031-.154.113-.168.151,0,.007.188-.141.11-.086l-.1.072a2.58,2.58,0,0,1-.383.206l.246-.1a2.571,2.571,0,0,1-.64.175c.092-.014.182-.024.274-.038a2.647,2.647,0,0,1-.657,0c.092.014.181.024.274.038a2.656,2.656,0,0,1-.64-.175l.246.1a2.393,2.393,0,0,1-.322-.168c-.048-.031-.1-.062-.144-.1s-.109-.116.089.072c-.024-.024-.051-.041-.075-.065-.062-.055-.123-.116-.181-.174l-.592-.592a7.109,7.109,0,0,0-1.54-1.345,3.9,3.9,0,0,0-1.9-.431,1.041,1.041,0,0,0-1.027,1.027v9.459a1.012,1.012,0,0,0,.4.808.967.967,0,0,0,.9.185q2.243-.914,4.49-1.831c.209-.086.414-.171.623-.253h-.548q2.243.914,4.49,1.831c.209.086.414.171.623.253a.969.969,0,0,0,.9-.185,1,1,0,0,0,.4-.808v-9.459a1.023,1.023,0,1,0-2.047,0Z" transform="translate(-332.4 -658.894)"/></g></g></g>';
      icon_marker_active = '<g transform="translate(16.5 10) scale(0.8 0.8)"><path fill="#fff" d="M149.456,43.1c-.472.472-.951.941-1.42,1.42a3.55,3.55,0,0,0-1.02,2.471c0,.359,0,.722,0,1.081a9.617,9.617,0,0,1-.024,1.256c.014-.092.024-.181.038-.274a2.625,2.625,0,0,1-.171.623l.1-.246a2.944,2.944,0,0,1-.212.4c-.02.031-.044.062-.065.092-.055.089.181-.212.065-.086-.051.055-.1.113-.151.164s-.11.1-.164.151c-.106.1.1-.079.1-.079s-.079.055-.092.065a2.337,2.337,0,0,1-.418.226l.246-.1a2.628,2.628,0,0,1-.623.171l.274-.038a9.811,9.811,0,0,1-1.188.024c-.387,0-.77,0-1.157,0a3.572,3.572,0,0,0-2.488,1.044c-.3.3-.606.606-.91.91l-.445.445c-.062.062-.123.12-.188.178-.144.13.212-.147.051-.038a1.68,1.68,0,0,1-.164.106,2.494,2.494,0,0,1-.3.154l.246-.1a2.568,2.568,0,0,1-.64.175l.274-.038a2.639,2.639,0,0,1-.657,0l.274.038a2.652,2.652,0,0,1-.64-.175l.246.1a3.692,3.692,0,0,1-.5-.291c.281.178.051.034-.021-.034-.017-.017-.038-.034-.055-.055l-.335-.335-.986-.986a3.677,3.677,0,0,0-2.32-1.092c-.39-.034-.787-.01-1.177-.01a11.065,11.065,0,0,1-1.389-.024l.274.038a2.628,2.628,0,0,1-.623-.171l.246.1a2.944,2.944,0,0,1-.4-.212c-.031-.021-.062-.044-.092-.065-.089-.055.212.181.086.065-.055-.051-.113-.1-.164-.151s-.1-.11-.151-.164c-.1-.106.079.1.079.1s-.055-.079-.065-.092a2.337,2.337,0,0,1-.226-.418l.1.246a2.628,2.628,0,0,1-.171-.623c.014.092.024.181.038.274a9.815,9.815,0,0,1-.024-1.188c0-.387,0-.77,0-1.157a3.571,3.571,0,0,0-1.044-2.488c-.3-.3-.606-.606-.91-.91l-.445-.445c-.062-.062-.12-.123-.178-.188-.13-.144.147.212.038.051a1.675,1.675,0,0,1-.106-.164,2.485,2.485,0,0,1-.154-.3l.1.246a2.57,2.57,0,0,1-.174-.64c.014.092.024.181.038.274a2.637,2.637,0,0,1,0-.657c-.014.092-.024.181-.038.274a2.652,2.652,0,0,1,.174-.64l-.1.246a3.691,3.691,0,0,1,.291-.5c-.178.281-.034.051.034-.021.017-.017.034-.038.055-.055l.335-.335.986-.986a3.669,3.669,0,0,0,1.092-2.32c.034-.39.01-.787.01-1.177a11.07,11.07,0,0,1,.024-1.389c-.014.092-.024.181-.038.274a2.629,2.629,0,0,1,.171-.623l-.1.246a2.941,2.941,0,0,1,.212-.4c.02-.031.045-.062.065-.092.055-.089-.181.212-.065.086.051-.055.1-.113.151-.164s.109-.1.164-.151c.106-.1-.1.079-.1.079s.079-.055.092-.065a2.335,2.335,0,0,1,.417-.226l-.246.1a2.627,2.627,0,0,1,.623-.171l-.274.038a9.809,9.809,0,0,1,1.188-.024c.387,0,.77,0,1.157,0a3.572,3.572,0,0,0,2.488-1.044c.3-.3.606-.606.91-.91l.445-.445c.062-.062.123-.12.188-.178.144-.13-.212.147-.051.038a1.682,1.682,0,0,1,.164-.106,2.5,2.5,0,0,1,.3-.154l-.246.1a2.569,2.569,0,0,1,.64-.175l-.274.038a2.638,2.638,0,0,1,.657,0l-.274-.038a2.651,2.651,0,0,1,.64.175l-.246-.1a3.687,3.687,0,0,1,.5.291c-.281-.178-.051-.034.021.034.017.017.038.034.055.055l.335.335.986.986a3.677,3.677,0,0,0,2.32,1.092c.39.034.787.01,1.177.01a11.064,11.064,0,0,1,1.389.024l-.274-.038a2.628,2.628,0,0,1,.623.171l-.246-.1a2.948,2.948,0,0,1,.4.212c.031.021.062.044.092.065.089.055-.212-.181-.086-.065.055.051.113.1.164.151s.1.11.151.164c.1.106-.079-.1-.079-.1s.055.079.065.092a2.341,2.341,0,0,1,.226.418l-.1-.246a2.626,2.626,0,0,1,.171.623c-.014-.092-.024-.181-.038-.274a9.805,9.805,0,0,1,.024,1.188c0,.387,0,.77,0,1.157a3.571,3.571,0,0,0,1.044,2.488c.3.3.606.606.91.91l.445.445c.062.062.12.123.178.188.13.144-.147-.212-.038-.051a1.672,1.672,0,0,1,.106.164,2.491,2.491,0,0,1,.154.3l-.1-.246a2.571,2.571,0,0,1,.175.64c-.014-.092-.024-.181-.038-.274a2.636,2.636,0,0,1,0,.657c.014-.092.024-.181.038-.274a2.654,2.654,0,0,1-.175.64l.1-.246a2.739,2.739,0,0,1-.205.383c-.017.027-.038.055-.055.082-.079.116.065-.079.072-.089a1.09,1.09,0,0,1-.175.181,1.026,1.026,0,1,0,1.451,1.451,3.523,3.523,0,0,0,.489-4.309,5.653,5.653,0,0,0-.78-.907l-.835-.835c-.092-.092-.188-.185-.281-.281-.068-.072-.13-.147-.2-.219.212.236.024.021-.027-.065a2.573,2.573,0,0,1-.147-.291l.1.246a2.559,2.559,0,0,1-.174-.633c.014.092.024.181.038.274a11.772,11.772,0,0,1-.024-1.475,6.982,6.982,0,0,0-.113-1.752,3.53,3.53,0,0,0-2.18-2.385,4.921,4.921,0,0,0-1.827-.212,13.482,13.482,0,0,1-1.7-.024l.274.038a2.559,2.559,0,0,1-.633-.175l.246.1a2.664,2.664,0,0,1-.339-.178c-.041-.024-.216-.154-.075-.045s-.048-.044-.086-.079-.1-.092-.144-.14l-.568-.568a9.519,9.519,0,0,0-1.342-1.232,3.516,3.516,0,0,0-3.46-.181,5.723,5.723,0,0,0-1.492,1.246l-.681.681c-.044.044-.089.092-.137.137s-.092.089-.144.133c-.014.014-.044.048-.065.051.048-.01.2-.147.051-.048a2.77,2.77,0,0,1-.407.222l.246-.1a2.56,2.56,0,0,1-.633.175l.274-.038a11.781,11.781,0,0,1-1.475.024,6.984,6.984,0,0,0-1.752.113A3.53,3.53,0,0,0,128.518,34a4.922,4.922,0,0,0-.212,1.827,13.48,13.48,0,0,1-.024,1.7c.014-.092.024-.181.038-.274a2.561,2.561,0,0,1-.175.633l.1-.246a2.661,2.661,0,0,1-.178.339c-.024.041-.154.216-.044.075s-.044.048-.079.086-.092.1-.14.144l-.568.568a9.518,9.518,0,0,0-1.232,1.342,3.517,3.517,0,0,0-.181,3.46,5.722,5.722,0,0,0,1.246,1.492l.681.681c.044.045.092.089.137.137s.089.092.133.144c.014.014.048.044.051.065-.01-.048-.147-.2-.048-.051a2.77,2.77,0,0,1,.222.407l-.1-.246a2.561,2.561,0,0,1,.175.633c-.014-.092-.024-.181-.038-.274a11.775,11.775,0,0,1,.024,1.475,6.984,6.984,0,0,0,.113,1.752,3.53,3.53,0,0,0,2.18,2.385,4.921,4.921,0,0,0,1.827.212,13.478,13.478,0,0,1,1.7.024l-.274-.038a2.56,2.56,0,0,1,.633.175l-.246-.1a2.665,2.665,0,0,1,.339.178c.041.024.216.154.075.044s.048.044.086.079.1.092.144.14l.568.568a9.518,9.518,0,0,0,1.342,1.232,3.516,3.516,0,0,0,3.46.181,5.721,5.721,0,0,0,1.492-1.246l.681-.681c.045-.045.089-.092.137-.137s.092-.089.144-.133c.014-.014.044-.048.065-.051-.048.01-.2.147-.051.048a2.768,2.768,0,0,1,.407-.222l-.246.1a2.558,2.558,0,0,1,.633-.175l-.274.038a11.778,11.778,0,0,1,1.475-.024,6.985,6.985,0,0,0,1.752-.113,3.53,3.53,0,0,0,2.385-2.18,4.921,4.921,0,0,0,.212-1.827,13.48,13.48,0,0,1,.024-1.7c-.014.092-.024.181-.038.274a2.559,2.559,0,0,1,.174-.633l-.1.246a2.669,2.669,0,0,1,.178-.339c.027-.044.065-.089.092-.137-.144.246-.079.1-.024.034s.106-.116.164-.171l.472-.472.9-.9a1.039,1.039,0,0,0,0-1.451A1.05,1.05,0,0,0,149.456,43.1Z" transform="translate(-125.457 -28.857)"/><g transform="translate(6.613 6.617)"><path fill="#fff" d="M329.861,228.831a5.663,5.663,0,0,1-.051.76c.014-.092.024-.181.038-.274a5.788,5.788,0,0,1-.387,1.417l.1-.246a5.681,5.681,0,0,1-.5.931c-.051.075-.1.147-.154.219-.1.144.062-.062.065-.082,0,.027-.065.079-.085.106-.113.137-.233.27-.359.4s-.247.236-.38.346c-.034.027-.068.055-.1.086-.092.079.212-.157.082-.065-.072.051-.144.106-.219.157a5.776,5.776,0,0,1-.948.517l.246-.1a5.541,5.541,0,0,1-1.417.387l.274-.038a5.924,5.924,0,0,1-1.516,0l.274.038A5.793,5.793,0,0,1,323.4,233l.246.1a5.688,5.688,0,0,1-.931-.5c-.075-.051-.147-.1-.219-.154-.144-.1.062.062.082.065-.027,0-.079-.065-.106-.086-.137-.113-.27-.233-.4-.359s-.236-.246-.346-.38c-.027-.034-.055-.068-.086-.1-.078-.092.158.212.065.082-.051-.072-.106-.144-.157-.219a5.764,5.764,0,0,1-.517-.948l.1.246a5.541,5.541,0,0,1-.387-1.417c.014.092.024.181.038.274a5.923,5.923,0,0,1,0-1.516c-.014.092-.024.181-.038.274a5.791,5.791,0,0,1,.387-1.417l-.1.246a5.683,5.683,0,0,1,.5-.931c.051-.075.1-.147.154-.219.1-.144-.062.062-.065.082,0-.027.065-.079.086-.106.113-.137.233-.27.359-.4s.246-.236.38-.346c.034-.027.068-.055.1-.086.092-.079-.212.157-.082.065.072-.051.144-.106.219-.157a5.759,5.759,0,0,1,.948-.517l-.246.1a5.539,5.539,0,0,1,1.417-.387l-.274.038a5.918,5.918,0,0,1,1.516,0c-.093-.014-.182-.024-.274-.038a5.8,5.8,0,0,1,1.417.387l-.246-.1a5.676,5.676,0,0,1,.931.5c.075.051.147.1.219.154.144.1-.062-.062-.082-.065.027,0,.079.065.106.086.137.113.27.233.4.359s.236.246.346.38c.027.034.055.068.086.1.079.092-.157-.212-.065-.082.051.072.106.144.157.219a5.768,5.768,0,0,1,.517.948l-.1-.246a5.536,5.536,0,0,1,.387,1.417c-.014-.092-.024-.181-.038-.274a6.969,6.969,0,0,1,.051.756,1.027,1.027,0,1,0,2.053,0,6.594,6.594,0,0,0-1.184-3.771,6.83,6.83,0,0,0-3.237-2.467,6.63,6.63,0,0,0-7.235,1.961,6.8,6.8,0,0,0-1.56,3.854,6.6,6.6,0,0,0,3.781,6.413,6.805,6.805,0,0,0,4.2.489,6.627,6.627,0,0,0,5.14-5.346,7.738,7.738,0,0,0,.1-1.126,1.028,1.028,0,0,0-2.057-.007Z" transform="translate(-318.68 -222.217)"/></g><g transform="translate(7.082 21.561)"><g transform="translate(0 0)"><path fill="#fff" d="M342.633,659.921v9.459c.435-.329.866-.661,1.3-.989l-4.511-1.841c-.2-.082-.393-.171-.6-.243a1.255,1.255,0,0,0-.941.154c-.876.356-1.749.715-2.625,1.071l-2.1.859c.435.329.866.661,1.3.989v-9.459l-1.027,1.027a4.309,4.309,0,0,1,.554.024l-.274-.037a2.542,2.542,0,0,1,.633.175l-.246-.1a2.686,2.686,0,0,1,.339.178c.041.024.216.154.075.044s.048.045.086.079.1.093.144.14l.568.568a9.531,9.531,0,0,0,1.341,1.232,3.516,3.516,0,0,0,3.46.181,5.722,5.722,0,0,0,1.492-1.246l.681-.681c.045-.044.089-.092.137-.137s.092-.089.144-.133c.014-.014.045-.048.065-.051-.048.01-.2.147-.051.048a2.76,2.76,0,0,1,.407-.222l-.246.1a2.542,2.542,0,0,1,.633-.175l-.274.037a4.308,4.308,0,0,1,.554-.024,1.027,1.027,0,0,0,0-2.053,4.035,4.035,0,0,0-.5.017,3.976,3.976,0,0,0-1.2.322,3.545,3.545,0,0,0-1.054.756l-1.225,1.225-.14.14c-.031.031-.154.113-.168.151,0,.007.188-.141.11-.086l-.1.072a2.58,2.58,0,0,1-.383.206l.246-.1a2.571,2.571,0,0,1-.64.175c.092-.014.182-.024.274-.038a2.647,2.647,0,0,1-.657,0c.092.014.181.024.274.038a2.656,2.656,0,0,1-.64-.175l.246.1a2.393,2.393,0,0,1-.322-.168c-.048-.031-.1-.062-.144-.1s-.109-.116.089.072c-.024-.024-.051-.041-.075-.065-.062-.055-.123-.116-.181-.174l-.592-.592a7.109,7.109,0,0,0-1.54-1.345,3.9,3.9,0,0,0-1.9-.431,1.041,1.041,0,0,0-1.027,1.027v9.459a1.012,1.012,0,0,0,.4.808.967.967,0,0,0,.9.185q2.243-.914,4.49-1.831c.209-.086.414-.171.623-.253h-.548q2.243.914,4.49,1.831c.209.086.414.171.623.253a.969.969,0,0,0,.9-.185,1,1,0,0,0,.4-.808v-9.459a1.023,1.023,0,1,0-2.047,0Z" transform="translate(-332.4 -658.894)"/></g></g></g>';
    }
    else {
      icon_picture = 'm2';
      if (!alerte.locality || commune_abonne == -1) {
        // BLEU
        // color_1 = '#bc6c1c';
        // color_2 = '#db924a';
      }
      else {
        // ORANGE
        icon_marker = '<g transform="translate(16.5 10) scale(0.8 0.8)"><path fill="#40a8d1" d="M149.456,43.1c-.472.472-.951.941-1.42,1.42a3.55,3.55,0,0,0-1.02,2.471c0,.359,0,.722,0,1.081a9.617,9.617,0,0,1-.024,1.256c.014-.092.024-.181.038-.274a2.625,2.625,0,0,1-.171.623l.1-.246a2.944,2.944,0,0,1-.212.4c-.02.031-.044.062-.065.092-.055.089.181-.212.065-.086-.051.055-.1.113-.151.164s-.11.1-.164.151c-.106.1.1-.079.1-.079s-.079.055-.092.065a2.337,2.337,0,0,1-.418.226l.246-.1a2.628,2.628,0,0,1-.623.171l.274-.038a9.811,9.811,0,0,1-1.188.024c-.387,0-.77,0-1.157,0a3.572,3.572,0,0,0-2.488,1.044c-.3.3-.606.606-.91.91l-.445.445c-.062.062-.123.12-.188.178-.144.13.212-.147.051-.038a1.68,1.68,0,0,1-.164.106,2.494,2.494,0,0,1-.3.154l.246-.1a2.568,2.568,0,0,1-.64.175l.274-.038a2.639,2.639,0,0,1-.657,0l.274.038a2.652,2.652,0,0,1-.64-.175l.246.1a3.692,3.692,0,0,1-.5-.291c.281.178.051.034-.021-.034-.017-.017-.038-.034-.055-.055l-.335-.335-.986-.986a3.677,3.677,0,0,0-2.32-1.092c-.39-.034-.787-.01-1.177-.01a11.065,11.065,0,0,1-1.389-.024l.274.038a2.628,2.628,0,0,1-.623-.171l.246.1a2.944,2.944,0,0,1-.4-.212c-.031-.021-.062-.044-.092-.065-.089-.055.212.181.086.065-.055-.051-.113-.1-.164-.151s-.1-.11-.151-.164c-.1-.106.079.1.079.1s-.055-.079-.065-.092a2.337,2.337,0,0,1-.226-.418l.1.246a2.628,2.628,0,0,1-.171-.623c.014.092.024.181.038.274a9.815,9.815,0,0,1-.024-1.188c0-.387,0-.77,0-1.157a3.571,3.571,0,0,0-1.044-2.488c-.3-.3-.606-.606-.91-.91l-.445-.445c-.062-.062-.12-.123-.178-.188-.13-.144.147.212.038.051a1.675,1.675,0,0,1-.106-.164,2.485,2.485,0,0,1-.154-.3l.1.246a2.57,2.57,0,0,1-.174-.64c.014.092.024.181.038.274a2.637,2.637,0,0,1,0-.657c-.014.092-.024.181-.038.274a2.652,2.652,0,0,1,.174-.64l-.1.246a3.691,3.691,0,0,1,.291-.5c-.178.281-.034.051.034-.021.017-.017.034-.038.055-.055l.335-.335.986-.986a3.669,3.669,0,0,0,1.092-2.32c.034-.39.01-.787.01-1.177a11.07,11.07,0,0,1,.024-1.389c-.014.092-.024.181-.038.274a2.629,2.629,0,0,1,.171-.623l-.1.246a2.941,2.941,0,0,1,.212-.4c.02-.031.045-.062.065-.092.055-.089-.181.212-.065.086.051-.055.1-.113.151-.164s.109-.1.164-.151c.106-.1-.1.079-.1.079s.079-.055.092-.065a2.335,2.335,0,0,1,.417-.226l-.246.1a2.627,2.627,0,0,1,.623-.171l-.274.038a9.809,9.809,0,0,1,1.188-.024c.387,0,.77,0,1.157,0a3.572,3.572,0,0,0,2.488-1.044c.3-.3.606-.606.91-.91l.445-.445c.062-.062.123-.12.188-.178.144-.13-.212.147-.051.038a1.682,1.682,0,0,1,.164-.106,2.5,2.5,0,0,1,.3-.154l-.246.1a2.569,2.569,0,0,1,.64-.175l-.274.038a2.638,2.638,0,0,1,.657,0l-.274-.038a2.651,2.651,0,0,1,.64.175l-.246-.1a3.687,3.687,0,0,1,.5.291c-.281-.178-.051-.034.021.034.017.017.038.034.055.055l.335.335.986.986a3.677,3.677,0,0,0,2.32,1.092c.39.034.787.01,1.177.01a11.064,11.064,0,0,1,1.389.024l-.274-.038a2.628,2.628,0,0,1,.623.171l-.246-.1a2.948,2.948,0,0,1,.4.212c.031.021.062.044.092.065.089.055-.212-.181-.086-.065.055.051.113.1.164.151s.1.11.151.164c.1.106-.079-.1-.079-.1s.055.079.065.092a2.341,2.341,0,0,1,.226.418l-.1-.246a2.626,2.626,0,0,1,.171.623c-.014-.092-.024-.181-.038-.274a9.805,9.805,0,0,1,.024,1.188c0,.387,0,.77,0,1.157a3.571,3.571,0,0,0,1.044,2.488c.3.3.606.606.91.91l.445.445c.062.062.12.123.178.188.13.144-.147-.212-.038-.051a1.672,1.672,0,0,1,.106.164,2.491,2.491,0,0,1,.154.3l-.1-.246a2.571,2.571,0,0,1,.175.64c-.014-.092-.024-.181-.038-.274a2.636,2.636,0,0,1,0,.657c.014-.092.024-.181.038-.274a2.654,2.654,0,0,1-.175.64l.1-.246a2.739,2.739,0,0,1-.205.383c-.017.027-.038.055-.055.082-.079.116.065-.079.072-.089a1.09,1.09,0,0,1-.175.181,1.026,1.026,0,1,0,1.451,1.451,3.523,3.523,0,0,0,.489-4.309,5.653,5.653,0,0,0-.78-.907l-.835-.835c-.092-.092-.188-.185-.281-.281-.068-.072-.13-.147-.2-.219.212.236.024.021-.027-.065a2.573,2.573,0,0,1-.147-.291l.1.246a2.559,2.559,0,0,1-.174-.633c.014.092.024.181.038.274a11.772,11.772,0,0,1-.024-1.475,6.982,6.982,0,0,0-.113-1.752,3.53,3.53,0,0,0-2.18-2.385,4.921,4.921,0,0,0-1.827-.212,13.482,13.482,0,0,1-1.7-.024l.274.038a2.559,2.559,0,0,1-.633-.175l.246.1a2.664,2.664,0,0,1-.339-.178c-.041-.024-.216-.154-.075-.045s-.048-.044-.086-.079-.1-.092-.144-.14l-.568-.568a9.519,9.519,0,0,0-1.342-1.232,3.516,3.516,0,0,0-3.46-.181,5.723,5.723,0,0,0-1.492,1.246l-.681.681c-.044.044-.089.092-.137.137s-.092.089-.144.133c-.014.014-.044.048-.065.051.048-.01.2-.147.051-.048a2.77,2.77,0,0,1-.407.222l.246-.1a2.56,2.56,0,0,1-.633.175l.274-.038a11.781,11.781,0,0,1-1.475.024,6.984,6.984,0,0,0-1.752.113A3.53,3.53,0,0,0,128.518,34a4.922,4.922,0,0,0-.212,1.827,13.48,13.48,0,0,1-.024,1.7c.014-.092.024-.181.038-.274a2.561,2.561,0,0,1-.175.633l.1-.246a2.661,2.661,0,0,1-.178.339c-.024.041-.154.216-.044.075s-.044.048-.079.086-.092.1-.14.144l-.568.568a9.518,9.518,0,0,0-1.232,1.342,3.517,3.517,0,0,0-.181,3.46,5.722,5.722,0,0,0,1.246,1.492l.681.681c.044.045.092.089.137.137s.089.092.133.144c.014.014.048.044.051.065-.01-.048-.147-.2-.048-.051a2.77,2.77,0,0,1,.222.407l-.1-.246a2.561,2.561,0,0,1,.175.633c-.014-.092-.024-.181-.038-.274a11.775,11.775,0,0,1,.024,1.475,6.984,6.984,0,0,0,.113,1.752,3.53,3.53,0,0,0,2.18,2.385,4.921,4.921,0,0,0,1.827.212,13.478,13.478,0,0,1,1.7.024l-.274-.038a2.56,2.56,0,0,1,.633.175l-.246-.1a2.665,2.665,0,0,1,.339.178c.041.024.216.154.075.044s.048.044.086.079.1.092.144.14l.568.568a9.518,9.518,0,0,0,1.342,1.232,3.516,3.516,0,0,0,3.46.181,5.721,5.721,0,0,0,1.492-1.246l.681-.681c.045-.045.089-.092.137-.137s.092-.089.144-.133c.014-.014.044-.048.065-.051-.048.01-.2.147-.051.048a2.768,2.768,0,0,1,.407-.222l-.246.1a2.558,2.558,0,0,1,.633-.175l-.274.038a11.778,11.778,0,0,1,1.475-.024,6.985,6.985,0,0,0,1.752-.113,3.53,3.53,0,0,0,2.385-2.18,4.921,4.921,0,0,0,.212-1.827,13.48,13.48,0,0,1,.024-1.7c-.014.092-.024.181-.038.274a2.559,2.559,0,0,1,.174-.633l-.1.246a2.669,2.669,0,0,1,.178-.339c.027-.044.065-.089.092-.137-.144.246-.079.1-.024.034s.106-.116.164-.171l.472-.472.9-.9a1.039,1.039,0,0,0,0-1.451A1.05,1.05,0,0,0,149.456,43.1Z" transform="translate(-125.457 -28.857)"/><g transform="translate(6.613 6.617)"><path fill="#40a8d1" d="M329.861,228.831a5.663,5.663,0,0,1-.051.76c.014-.092.024-.181.038-.274a5.788,5.788,0,0,1-.387,1.417l.1-.246a5.681,5.681,0,0,1-.5.931c-.051.075-.1.147-.154.219-.1.144.062-.062.065-.082,0,.027-.065.079-.085.106-.113.137-.233.27-.359.4s-.247.236-.38.346c-.034.027-.068.055-.1.086-.092.079.212-.157.082-.065-.072.051-.144.106-.219.157a5.776,5.776,0,0,1-.948.517l.246-.1a5.541,5.541,0,0,1-1.417.387l.274-.038a5.924,5.924,0,0,1-1.516,0l.274.038A5.793,5.793,0,0,1,323.4,233l.246.1a5.688,5.688,0,0,1-.931-.5c-.075-.051-.147-.1-.219-.154-.144-.1.062.062.082.065-.027,0-.079-.065-.106-.086-.137-.113-.27-.233-.4-.359s-.236-.246-.346-.38c-.027-.034-.055-.068-.086-.1-.078-.092.158.212.065.082-.051-.072-.106-.144-.157-.219a5.764,5.764,0,0,1-.517-.948l.1.246a5.541,5.541,0,0,1-.387-1.417c.014.092.024.181.038.274a5.923,5.923,0,0,1,0-1.516c-.014.092-.024.181-.038.274a5.791,5.791,0,0,1,.387-1.417l-.1.246a5.683,5.683,0,0,1,.5-.931c.051-.075.1-.147.154-.219.1-.144-.062.062-.065.082,0-.027.065-.079.086-.106.113-.137.233-.27.359-.4s.246-.236.38-.346c.034-.027.068-.055.1-.086.092-.079-.212.157-.082.065.072-.051.144-.106.219-.157a5.759,5.759,0,0,1,.948-.517l-.246.1a5.539,5.539,0,0,1,1.417-.387l-.274.038a5.918,5.918,0,0,1,1.516,0c-.093-.014-.182-.024-.274-.038a5.8,5.8,0,0,1,1.417.387l-.246-.1a5.676,5.676,0,0,1,.931.5c.075.051.147.1.219.154.144.1-.062-.062-.082-.065.027,0,.079.065.106.086.137.113.27.233.4.359s.236.246.346.38c.027.034.055.068.086.1.079.092-.157-.212-.065-.082.051.072.106.144.157.219a5.768,5.768,0,0,1,.517.948l-.1-.246a5.536,5.536,0,0,1,.387,1.417c-.014-.092-.024-.181-.038-.274a6.969,6.969,0,0,1,.051.756,1.027,1.027,0,1,0,2.053,0,6.594,6.594,0,0,0-1.184-3.771,6.83,6.83,0,0,0-3.237-2.467,6.63,6.63,0,0,0-7.235,1.961,6.8,6.8,0,0,0-1.56,3.854,6.6,6.6,0,0,0,3.781,6.413,6.805,6.805,0,0,0,4.2.489,6.627,6.627,0,0,0,5.14-5.346,7.738,7.738,0,0,0,.1-1.126,1.028,1.028,0,0,0-2.057-.007Z" transform="translate(-318.68 -222.217)"/></g><g transform="translate(7.082 21.561)"><g transform="translate(0 0)"><path fill="#40a8d1" d="M342.633,659.921v9.459c.435-.329.866-.661,1.3-.989l-4.511-1.841c-.2-.082-.393-.171-.6-.243a1.255,1.255,0,0,0-.941.154c-.876.356-1.749.715-2.625,1.071l-2.1.859c.435.329.866.661,1.3.989v-9.459l-1.027,1.027a4.309,4.309,0,0,1,.554.024l-.274-.037a2.542,2.542,0,0,1,.633.175l-.246-.1a2.686,2.686,0,0,1,.339.178c.041.024.216.154.075.044s.048.045.086.079.1.093.144.14l.568.568a9.531,9.531,0,0,0,1.341,1.232,3.516,3.516,0,0,0,3.46.181,5.722,5.722,0,0,0,1.492-1.246l.681-.681c.045-.044.089-.092.137-.137s.092-.089.144-.133c.014-.014.045-.048.065-.051-.048.01-.2.147-.051.048a2.76,2.76,0,0,1,.407-.222l-.246.1a2.542,2.542,0,0,1,.633-.175l-.274.037a4.308,4.308,0,0,1,.554-.024,1.027,1.027,0,0,0,0-2.053,4.035,4.035,0,0,0-.5.017,3.976,3.976,0,0,0-1.2.322,3.545,3.545,0,0,0-1.054.756l-1.225,1.225-.14.14c-.031.031-.154.113-.168.151,0,.007.188-.141.11-.086l-.1.072a2.58,2.58,0,0,1-.383.206l.246-.1a2.571,2.571,0,0,1-.64.175c.092-.014.182-.024.274-.038a2.647,2.647,0,0,1-.657,0c.092.014.181.024.274.038a2.656,2.656,0,0,1-.64-.175l.246.1a2.393,2.393,0,0,1-.322-.168c-.048-.031-.1-.062-.144-.1s-.109-.116.089.072c-.024-.024-.051-.041-.075-.065-.062-.055-.123-.116-.181-.174l-.592-.592a7.109,7.109,0,0,0-1.54-1.345,3.9,3.9,0,0,0-1.9-.431,1.041,1.041,0,0,0-1.027,1.027v9.459a1.012,1.012,0,0,0,.4.808.967.967,0,0,0,.9.185q2.243-.914,4.49-1.831c.209-.086.414-.171.623-.253h-.548q2.243.914,4.49,1.831c.209.086.414.171.623.253a.969.969,0,0,0,.9-.185,1,1,0,0,0,.4-.808v-9.459a1.023,1.023,0,1,0-2.047,0Z" transform="translate(-332.4 -658.894)"/></g></g></g>';
        icon_marker_active = '<g transform="translate(16.5 10) scale(0.8 0.8)"><path fill="#fff" d="M149.456,43.1c-.472.472-.951.941-1.42,1.42a3.55,3.55,0,0,0-1.02,2.471c0,.359,0,.722,0,1.081a9.617,9.617,0,0,1-.024,1.256c.014-.092.024-.181.038-.274a2.625,2.625,0,0,1-.171.623l.1-.246a2.944,2.944,0,0,1-.212.4c-.02.031-.044.062-.065.092-.055.089.181-.212.065-.086-.051.055-.1.113-.151.164s-.11.1-.164.151c-.106.1.1-.079.1-.079s-.079.055-.092.065a2.337,2.337,0,0,1-.418.226l.246-.1a2.628,2.628,0,0,1-.623.171l.274-.038a9.811,9.811,0,0,1-1.188.024c-.387,0-.77,0-1.157,0a3.572,3.572,0,0,0-2.488,1.044c-.3.3-.606.606-.91.91l-.445.445c-.062.062-.123.12-.188.178-.144.13.212-.147.051-.038a1.68,1.68,0,0,1-.164.106,2.494,2.494,0,0,1-.3.154l.246-.1a2.568,2.568,0,0,1-.64.175l.274-.038a2.639,2.639,0,0,1-.657,0l.274.038a2.652,2.652,0,0,1-.64-.175l.246.1a3.692,3.692,0,0,1-.5-.291c.281.178.051.034-.021-.034-.017-.017-.038-.034-.055-.055l-.335-.335-.986-.986a3.677,3.677,0,0,0-2.32-1.092c-.39-.034-.787-.01-1.177-.01a11.065,11.065,0,0,1-1.389-.024l.274.038a2.628,2.628,0,0,1-.623-.171l.246.1a2.944,2.944,0,0,1-.4-.212c-.031-.021-.062-.044-.092-.065-.089-.055.212.181.086.065-.055-.051-.113-.1-.164-.151s-.1-.11-.151-.164c-.1-.106.079.1.079.1s-.055-.079-.065-.092a2.337,2.337,0,0,1-.226-.418l.1.246a2.628,2.628,0,0,1-.171-.623c.014.092.024.181.038.274a9.815,9.815,0,0,1-.024-1.188c0-.387,0-.77,0-1.157a3.571,3.571,0,0,0-1.044-2.488c-.3-.3-.606-.606-.91-.91l-.445-.445c-.062-.062-.12-.123-.178-.188-.13-.144.147.212.038.051a1.675,1.675,0,0,1-.106-.164,2.485,2.485,0,0,1-.154-.3l.1.246a2.57,2.57,0,0,1-.174-.64c.014.092.024.181.038.274a2.637,2.637,0,0,1,0-.657c-.014.092-.024.181-.038.274a2.652,2.652,0,0,1,.174-.64l-.1.246a3.691,3.691,0,0,1,.291-.5c-.178.281-.034.051.034-.021.017-.017.034-.038.055-.055l.335-.335.986-.986a3.669,3.669,0,0,0,1.092-2.32c.034-.39.01-.787.01-1.177a11.07,11.07,0,0,1,.024-1.389c-.014.092-.024.181-.038.274a2.629,2.629,0,0,1,.171-.623l-.1.246a2.941,2.941,0,0,1,.212-.4c.02-.031.045-.062.065-.092.055-.089-.181.212-.065.086.051-.055.1-.113.151-.164s.109-.1.164-.151c.106-.1-.1.079-.1.079s.079-.055.092-.065a2.335,2.335,0,0,1,.417-.226l-.246.1a2.627,2.627,0,0,1,.623-.171l-.274.038a9.809,9.809,0,0,1,1.188-.024c.387,0,.77,0,1.157,0a3.572,3.572,0,0,0,2.488-1.044c.3-.3.606-.606.91-.91l.445-.445c.062-.062.123-.12.188-.178.144-.13-.212.147-.051.038a1.682,1.682,0,0,1,.164-.106,2.5,2.5,0,0,1,.3-.154l-.246.1a2.569,2.569,0,0,1,.64-.175l-.274.038a2.638,2.638,0,0,1,.657,0l-.274-.038a2.651,2.651,0,0,1,.64.175l-.246-.1a3.687,3.687,0,0,1,.5.291c-.281-.178-.051-.034.021.034.017.017.038.034.055.055l.335.335.986.986a3.677,3.677,0,0,0,2.32,1.092c.39.034.787.01,1.177.01a11.064,11.064,0,0,1,1.389.024l-.274-.038a2.628,2.628,0,0,1,.623.171l-.246-.1a2.948,2.948,0,0,1,.4.212c.031.021.062.044.092.065.089.055-.212-.181-.086-.065.055.051.113.1.164.151s.1.11.151.164c.1.106-.079-.1-.079-.1s.055.079.065.092a2.341,2.341,0,0,1,.226.418l-.1-.246a2.626,2.626,0,0,1,.171.623c-.014-.092-.024-.181-.038-.274a9.805,9.805,0,0,1,.024,1.188c0,.387,0,.77,0,1.157a3.571,3.571,0,0,0,1.044,2.488c.3.3.606.606.91.91l.445.445c.062.062.12.123.178.188.13.144-.147-.212-.038-.051a1.672,1.672,0,0,1,.106.164,2.491,2.491,0,0,1,.154.3l-.1-.246a2.571,2.571,0,0,1,.175.64c-.014-.092-.024-.181-.038-.274a2.636,2.636,0,0,1,0,.657c.014-.092.024-.181.038-.274a2.654,2.654,0,0,1-.175.64l.1-.246a2.739,2.739,0,0,1-.205.383c-.017.027-.038.055-.055.082-.079.116.065-.079.072-.089a1.09,1.09,0,0,1-.175.181,1.026,1.026,0,1,0,1.451,1.451,3.523,3.523,0,0,0,.489-4.309,5.653,5.653,0,0,0-.78-.907l-.835-.835c-.092-.092-.188-.185-.281-.281-.068-.072-.13-.147-.2-.219.212.236.024.021-.027-.065a2.573,2.573,0,0,1-.147-.291l.1.246a2.559,2.559,0,0,1-.174-.633c.014.092.024.181.038.274a11.772,11.772,0,0,1-.024-1.475,6.982,6.982,0,0,0-.113-1.752,3.53,3.53,0,0,0-2.18-2.385,4.921,4.921,0,0,0-1.827-.212,13.482,13.482,0,0,1-1.7-.024l.274.038a2.559,2.559,0,0,1-.633-.175l.246.1a2.664,2.664,0,0,1-.339-.178c-.041-.024-.216-.154-.075-.045s-.048-.044-.086-.079-.1-.092-.144-.14l-.568-.568a9.519,9.519,0,0,0-1.342-1.232,3.516,3.516,0,0,0-3.46-.181,5.723,5.723,0,0,0-1.492,1.246l-.681.681c-.044.044-.089.092-.137.137s-.092.089-.144.133c-.014.014-.044.048-.065.051.048-.01.2-.147.051-.048a2.77,2.77,0,0,1-.407.222l.246-.1a2.56,2.56,0,0,1-.633.175l.274-.038a11.781,11.781,0,0,1-1.475.024,6.984,6.984,0,0,0-1.752.113A3.53,3.53,0,0,0,128.518,34a4.922,4.922,0,0,0-.212,1.827,13.48,13.48,0,0,1-.024,1.7c.014-.092.024-.181.038-.274a2.561,2.561,0,0,1-.175.633l.1-.246a2.661,2.661,0,0,1-.178.339c-.024.041-.154.216-.044.075s-.044.048-.079.086-.092.1-.14.144l-.568.568a9.518,9.518,0,0,0-1.232,1.342,3.517,3.517,0,0,0-.181,3.46,5.722,5.722,0,0,0,1.246,1.492l.681.681c.044.045.092.089.137.137s.089.092.133.144c.014.014.048.044.051.065-.01-.048-.147-.2-.048-.051a2.77,2.77,0,0,1,.222.407l-.1-.246a2.561,2.561,0,0,1,.175.633c-.014-.092-.024-.181-.038-.274a11.775,11.775,0,0,1,.024,1.475,6.984,6.984,0,0,0,.113,1.752,3.53,3.53,0,0,0,2.18,2.385,4.921,4.921,0,0,0,1.827.212,13.478,13.478,0,0,1,1.7.024l-.274-.038a2.56,2.56,0,0,1,.633.175l-.246-.1a2.665,2.665,0,0,1,.339.178c.041.024.216.154.075.044s.048.044.086.079.1.092.144.14l.568.568a9.518,9.518,0,0,0,1.342,1.232,3.516,3.516,0,0,0,3.46.181,5.721,5.721,0,0,0,1.492-1.246l.681-.681c.045-.045.089-.092.137-.137s.092-.089.144-.133c.014-.014.044-.048.065-.051-.048.01-.2.147-.051.048a2.768,2.768,0,0,1,.407-.222l-.246.1a2.558,2.558,0,0,1,.633-.175l-.274.038a11.778,11.778,0,0,1,1.475-.024,6.985,6.985,0,0,0,1.752-.113,3.53,3.53,0,0,0,2.385-2.18,4.921,4.921,0,0,0,.212-1.827,13.48,13.48,0,0,1,.024-1.7c-.014.092-.024.181-.038.274a2.559,2.559,0,0,1,.174-.633l-.1.246a2.669,2.669,0,0,1,.178-.339c.027-.044.065-.089.092-.137-.144.246-.079.1-.024.034s.106-.116.164-.171l.472-.472.9-.9a1.039,1.039,0,0,0,0-1.451A1.05,1.05,0,0,0,149.456,43.1Z" transform="translate(-125.457 -28.857)"/><g transform="translate(6.613 6.617)"><path fill="#fff" d="M329.861,228.831a5.663,5.663,0,0,1-.051.76c.014-.092.024-.181.038-.274a5.788,5.788,0,0,1-.387,1.417l.1-.246a5.681,5.681,0,0,1-.5.931c-.051.075-.1.147-.154.219-.1.144.062-.062.065-.082,0,.027-.065.079-.085.106-.113.137-.233.27-.359.4s-.247.236-.38.346c-.034.027-.068.055-.1.086-.092.079.212-.157.082-.065-.072.051-.144.106-.219.157a5.776,5.776,0,0,1-.948.517l.246-.1a5.541,5.541,0,0,1-1.417.387l.274-.038a5.924,5.924,0,0,1-1.516,0l.274.038A5.793,5.793,0,0,1,323.4,233l.246.1a5.688,5.688,0,0,1-.931-.5c-.075-.051-.147-.1-.219-.154-.144-.1.062.062.082.065-.027,0-.079-.065-.106-.086-.137-.113-.27-.233-.4-.359s-.236-.246-.346-.38c-.027-.034-.055-.068-.086-.1-.078-.092.158.212.065.082-.051-.072-.106-.144-.157-.219a5.764,5.764,0,0,1-.517-.948l.1.246a5.541,5.541,0,0,1-.387-1.417c.014.092.024.181.038.274a5.923,5.923,0,0,1,0-1.516c-.014.092-.024.181-.038.274a5.791,5.791,0,0,1,.387-1.417l-.1.246a5.683,5.683,0,0,1,.5-.931c.051-.075.1-.147.154-.219.1-.144-.062.062-.065.082,0-.027.065-.079.086-.106.113-.137.233-.27.359-.4s.246-.236.38-.346c.034-.027.068-.055.1-.086.092-.079-.212.157-.082.065.072-.051.144-.106.219-.157a5.759,5.759,0,0,1,.948-.517l-.246.1a5.539,5.539,0,0,1,1.417-.387l-.274.038a5.918,5.918,0,0,1,1.516,0c-.093-.014-.182-.024-.274-.038a5.8,5.8,0,0,1,1.417.387l-.246-.1a5.676,5.676,0,0,1,.931.5c.075.051.147.1.219.154.144.1-.062-.062-.082-.065.027,0,.079.065.106.086.137.113.27.233.4.359s.236.246.346.38c.027.034.055.068.086.1.079.092-.157-.212-.065-.082.051.072.106.144.157.219a5.768,5.768,0,0,1,.517.948l-.1-.246a5.536,5.536,0,0,1,.387,1.417c-.014-.092-.024-.181-.038-.274a6.969,6.969,0,0,1,.051.756,1.027,1.027,0,1,0,2.053,0,6.594,6.594,0,0,0-1.184-3.771,6.83,6.83,0,0,0-3.237-2.467,6.63,6.63,0,0,0-7.235,1.961,6.8,6.8,0,0,0-1.56,3.854,6.6,6.6,0,0,0,3.781,6.413,6.805,6.805,0,0,0,4.2.489,6.627,6.627,0,0,0,5.14-5.346,7.738,7.738,0,0,0,.1-1.126,1.028,1.028,0,0,0-2.057-.007Z" transform="translate(-318.68 -222.217)"/></g><g transform="translate(7.082 21.561)"><g transform="translate(0 0)"><path fill="#fff" d="M342.633,659.921v9.459c.435-.329.866-.661,1.3-.989l-4.511-1.841c-.2-.082-.393-.171-.6-.243a1.255,1.255,0,0,0-.941.154c-.876.356-1.749.715-2.625,1.071l-2.1.859c.435.329.866.661,1.3.989v-9.459l-1.027,1.027a4.309,4.309,0,0,1,.554.024l-.274-.037a2.542,2.542,0,0,1,.633.175l-.246-.1a2.686,2.686,0,0,1,.339.178c.041.024.216.154.075.044s.048.045.086.079.1.093.144.14l.568.568a9.531,9.531,0,0,0,1.341,1.232,3.516,3.516,0,0,0,3.46.181,5.722,5.722,0,0,0,1.492-1.246l.681-.681c.045-.044.089-.092.137-.137s.092-.089.144-.133c.014-.014.045-.048.065-.051-.048.01-.2.147-.051.048a2.76,2.76,0,0,1,.407-.222l-.246.1a2.542,2.542,0,0,1,.633-.175l-.274.037a4.308,4.308,0,0,1,.554-.024,1.027,1.027,0,0,0,0-2.053,4.035,4.035,0,0,0-.5.017,3.976,3.976,0,0,0-1.2.322,3.545,3.545,0,0,0-1.054.756l-1.225,1.225-.14.14c-.031.031-.154.113-.168.151,0,.007.188-.141.11-.086l-.1.072a2.58,2.58,0,0,1-.383.206l.246-.1a2.571,2.571,0,0,1-.64.175c.092-.014.182-.024.274-.038a2.647,2.647,0,0,1-.657,0c.092.014.181.024.274.038a2.656,2.656,0,0,1-.64-.175l.246.1a2.393,2.393,0,0,1-.322-.168c-.048-.031-.1-.062-.144-.1s-.109-.116.089.072c-.024-.024-.051-.041-.075-.065-.062-.055-.123-.116-.181-.174l-.592-.592a7.109,7.109,0,0,0-1.54-1.345,3.9,3.9,0,0,0-1.9-.431,1.041,1.041,0,0,0-1.027,1.027v9.459a1.012,1.012,0,0,0,.4.808.967.967,0,0,0,.9.185q2.243-.914,4.49-1.831c.209-.086.414-.171.623-.253h-.548q2.243.914,4.49,1.831c.209.086.414.171.623.253a.969.969,0,0,0,.9-.185,1,1,0,0,0,.4-.808v-9.459a1.023,1.023,0,1,0-2.047,0Z" transform="translate(-332.4 -658.894)"/></g></g></g>';

      }
    }

    let svg = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="55" height="63" viewBox="0 0 55 63"><defs><style>.a{fill:#fff;}.b,.c{stroke:none;}.c{fill:#40a8d1;}.d{filter:url(#a);}</style><filter id="a" x="0" y="0" width="55" height="63" filterUnits="userSpaceOnUse"><feOffset dy="6" input="SourceAlpha"/><feGaussianBlur stdDeviation="3" result="b"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter></defs><g class="d" transform="matrix(1, 0, 0, 1, 0, 0)"><g class="a" transform="translate(9 3)"><path class="b" d="M 18.50011444091797 43.72612762451172 C 17.10334777832031 42.60537338256836 13.51027297973633 39.62177658081055 9.959389686584473 35.85065841674805 C 5.87214994430542 31.50993919372559 1 25.21530914306641 1 19.87818908691406 C 1 17.3205509185791 1.465749979019165 14.84051990509033 2.384320020675659 12.50697994232178 C 3.270050048828125 10.25689029693604 4.537189960479736 8.23701000213623 6.15054988861084 6.503459930419922 C 9.453459739685059 2.954499959945679 13.83924007415771 1 18.5 1 C 23.1607608795166 1 27.54653930664062 2.954499959945679 30.84944915771484 6.503459930419922 C 32.46281051635742 8.23701000213623 33.72994995117188 10.25689029693604 34.61568069458008 12.50697994232178 C 35.53424835205078 14.84051990509033 36 17.3205509185791 36 19.87818908691406 C 36 25.22122955322266 31.11783981323242 31.52383041381836 27.02220916748047 35.87020111083984 C 23.4734935760498 39.63618087768555 19.89378929138184 42.6081657409668 18.50011444091797 43.72612762451172 Z"/><path class="c" d="M 18.5 2 C 14.12001037597656 2 9.994199752807617 3.84130859375 6.882579803466797 7.184738159179688 C 3.734001159667969 10.56787872314453 2 15.07583045959473 2 19.87818908691406 C 2 23.83856010437012 4.997749328613281 29.11798858642578 10.66916084289551 35.14572143554688 C 13.73951148986816 38.40897369384766 16.84658050537109 41.07897186279297 18.50037574768066 42.4379997253418 C 20.14568901062012 41.08646774291992 23.22966957092285 38.43678283691406 26.29442024230957 35.18439865112305 C 31.98966026306152 29.14048957824707 35 23.84769058227539 35 19.87818908691406 C 35 15.07583045959473 33.26599884033203 10.56787872314453 30.1174201965332 7.184738159179688 C 27.00580024719238 3.84130859375 22.87998962402344 2 18.5 2 M 18.5 0 C 28.71726989746094 0 37 8.899768829345703 37 19.87818908691406 C 37 30.85660934448242 18.5 45 18.5 45 C 18.5 45 0 30.85660934448242 0 19.87818908691406 C 0 8.899768829345703 8.282730102539062 0 18.5 0 Z"/></g>' + icon_marker + '</g></svg>';
    let svg_active = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="55" height="63" viewBox="0 0 55 63"><defs><style>.a{fill:#40a8d1;}.b,.c{stroke:none;}.c{fill:#fff;}.d{filter:url(#a);}</style><filter id="a" x="0" y="0" width="55" height="63" filterUnits="userSpaceOnUse"><feOffset dy="6" input="SourceAlpha"/><feGaussianBlur stdDeviation="3" result="b"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter></defs><g class="d" transform="matrix(1, 0, 0, 1, 0, 0)"><g class="a" transform="translate(9 3)"><path class="b" d="M 18.50011444091797 43.72612762451172 C 17.10334777832031 42.60537338256836 13.51027297973633 39.62177658081055 9.959389686584473 35.85065841674805 C 5.87214994430542 31.50993919372559 1 25.21530914306641 1 19.87818908691406 C 1 17.3205509185791 1.465749979019165 14.84051990509033 2.384320020675659 12.50697994232178 C 3.270050048828125 10.25689029693604 4.537189960479736 8.23701000213623 6.15054988861084 6.503459930419922 C 9.453459739685059 2.954499959945679 13.83924007415771 1 18.5 1 C 23.1607608795166 1 27.54653930664062 2.954499959945679 30.84944915771484 6.503459930419922 C 32.46281051635742 8.23701000213623 33.72994995117188 10.25689029693604 34.61568069458008 12.50697994232178 C 35.53424835205078 14.84051990509033 36 17.3205509185791 36 19.87818908691406 C 36 25.22122955322266 31.11783981323242 31.52383041381836 27.02220916748047 35.87020111083984 C 23.4734935760498 39.63618087768555 19.89378929138184 42.6081657409668 18.50011444091797 43.72612762451172 Z"/><path class="c" d="M 18.5 2 C 14.12001037597656 2 9.994199752807617 3.84130859375 6.882579803466797 7.184738159179688 C 3.734001159667969 10.56787872314453 2 15.07583045959473 2 19.87818908691406 C 2 23.83856010437012 4.997749328613281 29.11798858642578 10.66916084289551 35.14572143554688 C 13.73951148986816 38.40897369384766 16.84658050537109 41.07897186279297 18.50037574768066 42.4379997253418 C 20.14568901062012 41.08646774291992 23.22966957092285 38.43678283691406 26.29442024230957 35.18439865112305 C 31.98966026306152 29.14048957824707 35 23.84769058227539 35 19.87818908691406 C 35 15.07583045959473 33.26599884033203 10.56787872314453 30.1174201965332 7.184738159179688 C 27.00580024719238 3.84130859375 22.87998962402344 2 18.5 2 M 18.5 0 C 28.71726989746094 0 37 8.899768829345703 37 19.87818908691406 C 37 30.85660934448242 18.5 45 18.5 45 C 18.5 45 0 30.85660934448242 0 19.87818908691406 C 0 8.899768829345703 8.282730102539062 0 18.5 0 Z"/></g>' + icon_marker_active + '</g></svg>';
    let icon_url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(svg);
    let icon_url_active = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(svg_active);

    let icon = {
      url: icon_url,
      scaledSize: new google.maps.Size(45, 52),
      anchor: new google.maps.Point(20, 20),
    };
    let icon_active = {
      url: icon_url_active,
      scaledSize: new google.maps.Size(45, 52),
      anchor: new google.maps.Point(25, 25),
    };

    this.icons[i] = {};
    this.icons[i]["classic"] = icon;
    this.icons[i]["active"] = icon_active;
  }


  async presentModalRegister() {
    const modal = await this.modalController.create({
      component: RegisterPage,
      canDismiss: true
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    if (data.goTo != null) {
      if (data.goTo == 'login') {
        this.presentModalLogin();
      }
      if (data.goTo == 'register') {
        this.presentModalRegister();
      }
      if (data.goTo == 'lost-password') {
        this.presentModalLostPassword();
      }
    }
  }
  async presentModalLostPassword() {
    const modal = await this.modalController.create({
      component: LostPasswordPage,
      canDismiss: true
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    if (data.goTo != null) {
      if (data.goTo == 'login') {
        this.presentModalLogin();
      }
      if (data.goTo == 'register') {
        this.presentModalRegister();
      }
      if (data.goTo == 'lost-password') {
        this.presentModalLostPassword();
      }
    }
  }


  async presentModalLogin() {
    const modal = await this.modalController.create({
      component: LoginPage,
      canDismiss: true
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    if (data.goTo != null) {
      if (data.goTo == 'login') {
        this.presentModalLogin();
      }
      if (data.goTo == 'register') {
        this.presentModalRegister();
      }
      if (data.goTo == 'lost-password') {
        this.presentModalLostPassword();
      }
    }
  }

  async presentAlertLocation() {
    const alert = await this.alertController.create({
      mode: 'ios',
      header: 'Localisation introuvable',
      message: 'Aie ! Nous n\'avons pas réussi à vous localiser. <br /><br />Merci de modifier vos paramètres de géolocalisation pour que votre signalement de pollution soit transmis avec efficacité.',
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }
        // }, {
        //   text: 'Continuer',
        //   handler: () => {
        //     console.log('Confirm Okay');
        //     this.newAlerte(false);
        //   }
        // }
      ]
    });
    await alert.present();
  }
}
